import { render } from "./HeroiconsOutlineCurrencyDollar.vue?vue&type=template&id=164b3bef"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyDollar.vue"]])

export default __exports__